/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tb_Step_3_TitleInputs */

const en_mk_tb_step_3_title = /** @type {(inputs: Mk_Tb_Step_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit evidence for review`)
};

const id_mk_tb_step_3_title = /** @type {(inputs: Mk_Tb_Step_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirim bukti untuk ditinjau`)
};

/**
* | output |
* | --- |
* | "Submit evidence for review" |
*
* @param {Mk_Tb_Step_3_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tb_step_3_title = /** @type {((inputs?: Mk_Tb_Step_3_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tb_Step_3_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tb_step_3_title(inputs)
	return en_mk_tb_step_3_title(inputs)
});